import React from 'react';
import { motion } from 'framer-motion';
export function Training() {
  return <div className="pt-32 pb-24 min-h-screen bg-brand-50" data-id="element-312">
      <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-313">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="max-w-3xl mx-auto" data-id="element-314">
          <h1 className="text-5xl font-serif text-charcoal-900 mb-6" data-id="element-315">
            Flight Training
          </h1>
          <p className="text-xl text-gray-600 mb-12" data-id="element-316">
            Elevate your skills with our elite flight training programs. From
            private pilot certification to advanced type ratings in
            high-performance aircraft.
          </p>
          <div className="inline-block p-8 bg-white rounded-2xl shadow-xl" data-id="element-317">
            <h3 className="text-2xl font-serif text-brand-600 mb-4" data-id="element-318">
              Programs Available
            </h3>
            <ul className="text-left space-y-3 text-gray-700" data-id="element-319">
              <li className="flex items-center gap-2" data-id="element-320">
                ✓ Private Pilot License (PPL)
              </li>
              <li className="flex items-center gap-2" data-id="element-321">
                ✓ Instrument Rating (IR)
              </li>
              <li className="flex items-center gap-2" data-id="element-322">
                ✓ Commercial Pilot License (CPL)
              </li>
              <li className="flex items-center gap-2" data-id="element-323">✓ Multi-Engine Rating</li>
              <li className="flex items-center gap-2" data-id="element-324">
                ✓ Specific Type Ratings
              </li>
            </ul>
          </div>
        </motion.div>
      </div>
    </div>;
}